<template>
  <div class="notification_wrapper py-3">
    <div class="page_width margin_0_auto notification_container">
      <div>
        <!-- <div v-if="title" class="notification_title text_weight_600">
          <slot name="title">{{title}}</slot>
        </div> -->
        <div class="body mb-1">
          <slot name="body">{{ body }}</slot>
        </div>
      </div>
      <div class="buttons_container flexrow nowrap">
        <slot name="action">
          <a :href="actionButtonLink" target="_blank">
            <button
              class="
                numerai-button
                button-tertiary
                action_button
                notification_button
              "
            >
              {{ actionButtonText }}
            </button>
          </a>
        </slot>
        <slot name="dismiss">
          <button
            class="
              numerai-button
              button-tertiary
              dismiss_button
              ml-4
              notification_button
            "
            @click="dismissButtonFunction"
          >
            Dismiss
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    actionButtonLink: { type: String, default: null },
    dismissButtonFunction: { type: Function, default: null },
    title: { type: String, default: null },
    body: { type: String, default: null },
    actionButtonText: { type: String, default: null },
  },
}
</script>
<style scoped>
.notification_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-left: calc(var(--page-padding) + 5px);
  padding-right: calc(var(--page-padding) + 5px);
}

.notification_wrapper {
  background-color: #007cff;
  border-bottom: 0.5px solid blue;
}

.notification_title {
  font-size: 16px;
  color: white;
}

.body {
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.notification_button {
  color: white;
  padding: 0;
  font-size: 14px;
}

.notification_button:hover {
  opacity: 1;
  color: white !important;
}

.action_button {
  opacity: 1;
  text-decoration: underline;
}

.action_button:hover {
}

.dismiss_button {
  color: #fff;

  opacity: 0.6;
}
</style>
